import {createStore} from 'zustand';

interface ChartsFilterStore {
  status: string;

  setStatus: (status: string) => void;
  resetStatus: () => void;
}

export const createSecondaryChartsFiltersStore = () =>
  createStore<ChartsFilterStore>((set) => ({
    status: 'ALL',

    setStatus: (status) => set({status}),
    resetStatus: () => set({status: 'ALL'}),
  }));
